import { ReactElement } from 'react'
import { StickyFooter } from '@ui2/structure'
import RunningDocumentTasks from '../RunningDocumentTasks'
import useRunningDocumentTasks from '../RunningDocumentTasks/useRunningDocumentTasks'

// Footer of the "Dokumente anzeigen" view: only the running document tasks, shown while
// there are any (the navbar spinner doesn't cover them on this page)
const RunningDocumentTasksFooter = (): ReactElement | null => {
  const tasks = useRunningDocumentTasks()

  if (!tasks.length) return null

  return (
    <StickyFooter>
      <RunningDocumentTasks tasks={tasks} />
    </StickyFooter>
  )
}

export default RunningDocumentTasksFooter
